<!-- vertical layout -->
<sn-vertical *ngIf="isVerticalLayoutRequested()" [layoutWidth]="layoutWidth" [sidebarTheme]="leftSidebarTheme"
  [sidebarType]="leftSidebarWidth"></sn-vertical>


